import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-share-popup',
  templateUrl: './share-popup.component.html',
  styleUrls: ['./share-popup.component.scss']
})
export class SharePopupComponent implements OnInit {
  @Input() link: string;
  @Input() name: string;
  @Output() onConfirm = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  confirm(): void {
    this.onConfirm.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/share-popup/share-popup.component.ts